export const LOCALE = {
  ENGLISH: 'en-US',
  RUSSIAN: 'ru-RU',
  KAZAKH: 'kz-KZ',
}
